import { Image, Text } from "@mantine/core";
// import { useLocation } from "@reach/router";
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { navigate } from "gatsby";
import React, { useEffect, useState } from 'react';
import useLanguageNavigator from "../hooks/useLanguageNavigator";
import { availableLanguages, languages, LanguageSelector } from "./api";

const LangBar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { language, updateLanguage } = useLanguageNavigator(availableLanguages)
    // const location = useLocation()
    const handleLangSelect = (lang: LanguageSelector) => {
        updateLanguage(lang.code) // Update language
        handleLanguageChange(lang.code)
        setIsOpen(false) // Close dropdown
    }
    const handleLanguageChange = (newLanguage: string, shouldNavigate = true) => {
        if (language !== newLanguage) {
            const currentPath = window.location.pathname;
            const languagePattern = /^\/[a-z]{2}(\/|$)/;
            let newPath;
            if (newLanguage === "en") { // Remove any existing language prefix
                newPath = currentPath.replace(languagePattern, '/');
                newPath = newPath.replace('//', '/'); // Ensure no double slashes
            } else { // Replace existing language prefix with new one or add it if absent
                newPath = currentPath.replace(languagePattern, `/${newLanguage}/`);
                if (newPath === currentPath) {
                    newPath = `/${newLanguage}${currentPath}`;
                }
                newPath = newPath.replace('//', '/'); // Ensure no double slashes
            }
            step23(newPath, newLanguage)
        }
    };
    const step23 = (newPath: string, language: string) => {
        const path = window.location.pathname
        const html = document.documentElement;
        const cl = html.getAttribute("lang")
        const cd = html.getAttribute("dir")
        if (language === "ar") {
            if(cd !== "rtl") html.setAttribute("dir", "rtl");
            if(cl !== "ar") html.setAttribute("lang", "ar");
            // html.setAttribute("dir", "rtl");
            // html.setAttribute("lang", "ar");
        } else {
            if(cd !== "ltr") html.setAttribute("dir", "ltr");
            if(cl !== language) html.setAttribute("lang", language);
            // html.setAttribute("dir", "ltr");
            // html.setAttribute("lang", language);
        }
        updateLanguage(language);
        if (path !== newPath) {
            (navigate as unknown as (path: string, options?: { replace?: boolean }) => void)(newPath, { replace: true });
        }
    }
    useEffect(() => {
        const currentPath = window.location.pathname;
        const pathSegments = currentPath.split('/');
        let languageCode = pathSegments[1];
        const languagePattern = /^\/[a-z]{2}(\/|$)/;
        const hasLanguagePrefix = languagePattern.test(currentPath)
        let newPath = ''
        if (languageCode.length > 2 || languageCode.length === 0) {languageCode = "en"} // case 1, 3
        if (!availableLanguages.includes(languageCode)){languageCode = "en"} // case 5
        if (hasLanguagePrefix && languageCode === "en") { 
            newPath = currentPath.replace(/^\/en/, '/')
            newPath = newPath.replace('//', '/')
        }
        else if (!hasLanguagePrefix && languageCode !== "en") { newPath = `/${languageCode}${currentPath}`;} 
        else if (hasLanguagePrefix && languageCode !== "en") { 
            let newPath2 = currentPath.replace(languagePattern, '/');
            newPath2 = newPath2.replace('//', '/'); // Ensure no double slashes
            newPath = `/${languageCode}${newPath2}`;
        } 
        else if (!hasLanguagePrefix && languageCode === "en") { newPath = currentPath } 
        step23(newPath, languageCode)
    }, [])//location    
    return (
        <div className="lang-bar">
            <div className="lang-button" onClick={() => setIsOpen((prev) => !prev)}>
                <Image src={(languages.find((l) => l.code == language) as LanguageSelector  ?? language[1]).flag} w={24} />
                <Text size="xl" c={'ss.9'} fz={'h4'} ml={3} fw={500}>{(languages.find((l) => l.code == language) as LanguageSelector  ?? language[1]).name}</Text>
                {isOpen ? <IconChevronUp stroke={1.8} /> : <IconChevronDown stroke={1.8} />}
            </div>
            {isOpen && (
                <div className="lang-dropdown">
                    {languages.map((lang) => (
                        <div key={lang.code} className="lang-item" onClick={() => handleLangSelect(lang)}>
                            <Image src={lang.flag} w={25} />
                            <Text ml={10} c={'ss.9'} fz={'h4'} style={{ fontFamily: 'Fredoka' }}>{lang.name}</Text>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default LangBar